module.exports = __webpack_public_path__ + "static/img/album0.da507aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybenefits/album0.png
// module id = JiYd
// module chunks = 1